const Skeleton360Loader = () => {
  return (
    <div className="p-4 border rounded-lg bg-accent-0 animate-pulse m-4">
      <div className="h-6 bg-accent-300 rounded w-3/4 mb-4"></div>
      <div className="flex flex-col gap-3">
        <div className="flex gap-8">
          <div className="h-4 bg-accent-300 rounded w-[45%]"></div>
          <div className="h-4 bg-accent-300 rounded w-[45%]"></div>
        </div>
        <div className="flex gap-5">
          <div className="h-4 bg-accent-300 rounded w-[45%]"></div>
          <div className="h-4 bg-accent-300 rounded w-[45%]"></div>
        </div>
        <div className="flex gap-5">
          <div className="h-4 bg-accent-300 rounded w-[45%]"></div>
          <div className="h-4 bg-accent-300 rounded w-[45%]"></div>
        </div>
      </div>
    </div>
  )
}

export default Skeleton360Loader
